import {OnestSemiBoldBig} from "../styled/TextComponents";

export const PageTitle = ({title, fontSize, marginTop}) => {
    return (
        <div style={{
            width: "100%",
            marginBottom: 24,
            marginTop: marginTop ? marginTop : 0,
        }}>
            <OnestSemiBoldBig style={{fontSize: fontSize ? fontSize : 32}}>{title}</OnestSemiBoldBig>
        </div>
    )
}